import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function GoogleAnalytics() {
  const { data } = useQuery({
    queryKey: ['site-settings'],
    queryFn: async () => {
      const res = await fetch(`${API_BASE}/settings`);
      if (!res.ok) return { settings: {} };
      return res.json();
    },
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });

  const measurementId = data?.settings?.google_analytics_measurement_id;

  useEffect(() => {
    if (!measurementId || !measurementId.startsWith('G-')) return;
    if (document.querySelector(`script[src*="gtag/js?id=${measurementId}"]`)) return;

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', measurementId);
  }, [measurementId]);

  return null;
}
